import { render, staticRenderFns } from "./client-specific-fields-changes.vue?vue&type=template&id=7c5b985a&scoped=true"
import script from "./client-specific-fields-changes.vue?vue&type=script&lang=js"
export * from "./client-specific-fields-changes.vue?vue&type=script&lang=js"
import style0 from "./client-specific-fields-changes.vue?vue&type=style&index=0&id=7c5b985a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5b985a",
  null
  
)

export default component.exports